import Button from "@mui/material/Button";
import { removeBills } from "api/layer";
import Modal from "components/modal/modal";
import { AppAction, AppContext } from "helpers/context";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import styles from "./delete-modal.module.scss";

interface Props {
	data: any;
	initData: () => void;
	onClose: () => void;
}

const DeleteModal: React.FC<Props> = ({ data, initData, onClose }) => {
	const [t] = useTranslation();
	const [context, dispatch] = useContext(AppContext);

	const confirmDelete = (): void => {
		removeBills(data.id)
			.then((resp: any) => {
				if (!resp || resp.code !== 200) {
					dispatch({
						type: AppAction.addSnackBarParams,
						payload: {
							title: "deleteBill",
							titleIconColor: "yellow",
							titleIcon: "warning",
							resMessage: resp.message,
						},
					});
					return;
				}
				dispatch({
					type: AppAction.addSnackBarParams,
					payload: {
						title: "deleteBill",
						message: "deleteBillSuccess",
					},
				});
			})
			.catch((error: any) => {
				console.error(error);
				dispatch({
					type: AppAction.addSnackBarParams,
					payload: {
						title: "deleteBill",
						titleIconColor: "red",
						titleIcon: "error",
						message: "deleteBillError",
					},
				});
			})
			.finally(() => {
				initData();
				onClose();
			});
	};

	return (
		<Modal
			header={t("userSystem.deleteBill.title")}
			opened={!!data.id}
			onClose={onClose}
		>
			<div className={styles.info}>
				<div className={styles.text}>{`${t("userSystem.deleteBill.prefix")}${data.billName}${t("userSystem.deleteBill.suffix")}`}</div>

				<div className={styles.button}>
					<Button
						variant="text"
						color="success"
						onClick={onClose}
						style={{ outline: "none" }}
					>
						{t("buttons.cancel")}
					</Button>
					&nbsp;&nbsp;
					<Button
						variant="contained"
						color="error"
						onClick={confirmDelete}
					>
						{t("buttons.delete")}
					</Button>
				</div>
			</div>
		</Modal>
	);
};

export default DeleteModal;
